import {adbApi} from "./adbService";

export const authApi = adbApi.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (body) => ({
                url: `login`,
                method: "POST",
                body,
            }),
        }),
        logout: builder.query({
            query: () => ({
                url: "logout",
                method: "GET",
            }),
        }),
        getLoginPage: builder.query({
            query: () => ({
                url: "pages/auth/login",
                method: "GET",
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useLoginMutation,
    useLazyLogoutQuery,
    useLazyGetLoginPageQuery,
} = authApi;
